import {
  AppBar,
  Box,
  Button,
  Dialog,
  IconButton,
  Slide,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import AppBarCustom from "../component/AppBar";
import styled from "@emotion/styled";
import TableCustom from "../component/tableCustom";
import {
  AddRounded,
  CloseRounded,
  DeleteRounded,
  EditRounded,
  SearchRounded,
  UploadRounded,
} from "@mui/icons-material";
import react from "react";
import DetailDialog from "../component/DetailDialog";
import Api from "../api/RestApi.json";
import { useNavigate } from "react-router-dom";
import React from "react";
import axios from "axios";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function ArtikelPage(params) {
  const theme = useTheme();
  const goTo = useNavigate();
  const [row, setRow] = React.useState(params.data.filter((item)=>item.kategori!=="Kecamatan"));
  const [deleteStatus, setDeleteStatus] = React.useState(null);

  const file = params.file;

  const deletePost = async (id) => {
    setDeleteStatus(null);
    try {
      var response = "";
      response = await axios.delete(Api.artikel + "/" + id);
      if (response !== "") {
        setDeleteStatus("Data ID-" + id + " Berhasil dihapus");
        setRow(row.filter((item) => item.id !== id));
      }
    } catch (error) {
      console.error("Error delete file:", error);
      setDeleteStatus("File gagal dihapus. Tolong Muat Ulang Halaman.");
    }

    const profil = file.filter(
      (item) => item.kategori == "Profil" && item.id_foreign == id
    )[0];

    if (profil) {
      try {
        var deleteFile = "";
        deleteFile = await axios.delete(Api.file + "/" + profil.id);
      } catch (error) {}
    }
     const gambar = file.filter(
      (item) => item.kategori == "Gambar" && item.id_foreign == id
    )[0];

    if (gambar) {
      try {
        var deleteFile = "";
        deleteFile = await axios.delete(Api.file + "/" + gambar.id);
      } catch (error) {}
    }
        goTo(0);

  };

  const columns = [
    {
      field: "nomor",
      headerName: "No",
      flex: 1,
      minWidth: 30,
    },

    {
      field: "kategori",
      headerName: "Kategori",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "judul",
      headerName: "Judul",
      flex: 3,
      minWidth: 150,
    },
    {
      field: "penulis",
      headerName: "Penulis",
      flex: 3,
      minWidth: 150,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 3,
      minWidth: 150,
      align: "center",
      renderCell: (params) => {
        const [open, SetOpen] = react.useState(false);

        const handleClickOpen = () => {
          SetOpen(true);
        };

        const handleClickClose = () => {
          SetOpen(false);
        };
        return (
          // <Button onClick={(e) => console.log(params.row)} variant="contained">
          //   Show
          // </Button>
          <Stack direction={"row"} spacing={1}>
            {/* <Dialog
              fullScreen
              open={open}
              onClose={handleClickClose}
              slots={{
                transition: Transition,
              }}
            >
              {" "}
              <AppBar sx={{ position: "fixed", bgcolor: "red" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClickClose}
                    aria-label="close"
                  >
                    <CloseRounded fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1 }}
                    variant="h3"
                    align="center"
                    fontWeight={"bold"}
                    component="div"
                  >
                    {params.row.nama}
                  </Typography>
                </Toolbar>
              </AppBar>
              <Toolbar />
              <DetailDialog
                data={params.row}
                file={file.filter(
                  (item) =>
                    item.kategori == "Infrastruktur" &&
                    item.id_foreign == params.row.id
                )}
              />
            </Dialog>

            <Tooltip title="Tampilkan Detail Data">
              <IconButton onClick={handleClickOpen}>
                <SearchRounded color="info" />
              </IconButton>
            </Tooltip> */}

            <Tooltip title="Edit Data">
              <IconButton
                onClick={(e) =>
                  goTo("/artikel-form", {
                    state: {
                      data: params.row,
                      lastProfil: file.filter(
                        (item) =>
                          item.kategori == "Profil" &&
                          item.id_foreign == params.row.id
                      )[0],
                      lastGambar: file.filter(
                        (item) =>
                          item.kategori == "Gambar" &&
                          item.id_foreign == params.row.id
                      )[0],
                    },
                  })
                }
              >
                <EditRounded color="warning" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Hapus Data">
              <IconButton
                onClick={(e) => {
                  deletePost(params.row.id);
                }}
              >
                <DeleteRounded color="error" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Artikel & Berita" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: 2 }}
          align="left"
        >
          Berita
        </Typography>

        <Box padding={2} bgcolor={"white"} borderRadius={4}>
          <Box flexGrow={1} justifyContent={"right"} justifySelf={"right"}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddRounded />}
              onClick={(e) =>
                goTo("/artikel-form", {
                  state: {
                    data: {},
                    lastProfil: {},
                    lastGambar: {},
                  },
                })
              }
            >
              Tambah Data
            </Button>
          </Box>

          {deleteStatus && (
            <Typography
              variant="body2"
              color="error.main"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <DeleteRounded sx={{ ml: 1 }} /> {deleteStatus}
            </Typography>
          )}
          <TableCustom
            column={columns}
            row={row.map((item, index) => ({
              nomor: index + 1,
              ...item,
            }))}
          />
        </Box>
      </Box>
    </Box>
  );
}
const Transition = react.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
